export const shouldRetry = (count, error) => {
  if (error && error.response && error.response.status === 401) {
    return false
  }
  return count <= 2
}
